'use strict';

angular.module('amexReconciliationApp')
  .service('AssociateAccountingDetailsRepository', function ($http) {
    var self = this;

    self.copy = function (transactionIds, tpdId) {
      return $http.post('/api/v1/copyAccountingDetails',
        {
          transactionIds: transactionIds,
          tpdId: tpdId
        }
      );
    };

    self.link = function (transactionIds, tpdId) {
      return $http.post('/api/v1/linkTravelData',
        {
          transactionIds: transactionIds,
          tpdId: tpdId
        }
      );
    };

    self.unlink = function (transactionIds) {
      return $http.post('/api/v1/unlinkTravelData',
        {
          transactionIds: transactionIds
        }
      );
    };
  });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/repositories/AssociateAccountingDetailsRepository.js
// module id = 602
// module chunks = 0